import React from 'react';
import store from '../../../stores/store';
import { observer } from 'mobx-react';
import WarCatCard from './WarCatCard';
import WarDocCard from './WarDocCard';
import Breadcrumb from './Breadcrumb';
import * as local from '../../../helpers/localStorage';
import { compareDateString } from '../../../helpers/utils';

const WarPanel = observer(
    class VotePanel extends React.Component {
        constructor() {
            super();

            this.state = {
                parentCategoryId: 0,
                breadcrumbs: [],
            };
        }

        goToNextLevel = (parentCategoryId, categoryName) => {
            var breadcrumbs = this.state.breadcrumbs;

            breadcrumbs.push([parentCategoryId, categoryName]);

            this.setState({
                parentCategoryId,
                breadcrumbs,
            });
        };

        goBackToPreviousLevel = (parCategoryId, categoryName) => {
            let parentCategoryId = Number(parCategoryId);
            if (parentCategoryId !== this.state.parentCategoryId) {
                let index = null;
                let breadcrumbs = this.state.breadcrumbs;

                breadcrumbs.forEach((breadcrumb, i) => {
                    if (breadcrumb[0] === parentCategoryId) {
                        index = i;
                    }
                });
                breadcrumbs.length = index + 1;

                this.setState({
                    parentCategoryId,
                    breadcrumbs,
                });
            }
        };

        goBackToTopLevel = () => {
            this.setState({
                parentCategoryId: 0,
                breadcrumbs: [],
            });
        };

        markDocAsRead = doc => {
            store.war.setLoading(true);
            local.markWarDocAsRead(doc);
            store.war.setLoading(false);
        };

        fetchDocument = (
            instanceId,
            docTypeId,
            docId,
            DocExtension,
            DocPermissions,
            DocName,
            DocAnnotations,
        ) => {
            store.documents
                .fetchDocument(
                    instanceId,
                    docTypeId,
                    docId,
                    DocExtension,
                    DocPermissions,
                    DocName,
                    DocAnnotations,
                )
                .catch(error => {
                    console.log('error fetching doc - WAR panel');
                });
        };

        render() {
            let loading = store.war.loading;
            if (loading) {
                return null;
            }
            const parentCategoryId = this.state.parentCategoryId;
            const warArray = store.war
                .getAllChildCategories(this.state.parentCategoryId)
                .sort((first, second) => {
                    return first.CategoryName.toLowerCase().localeCompare(
                        second.CategoryName.toLowerCase(),
                    );
                });
            let docArray = [];
            let areDocsNew = {};
            let shouldDisplayDocs = warArray.length === 0;
            if (shouldDisplayDocs) {
                var warDocs = store.war.getCategory(parentCategoryId);
                if(warDocs !== undefined) {
                    docArray = store.war.getCategory(parentCategoryId).WarDocs.sort((first, second) => {
                        return compareDateString(first.DocCreated, second.DocCreated);
                    });
                }
                
                areDocsNew = local.areDocsNew(parentCategoryId);
            }

            const areCatsNew = local.areChildCatsNew(parentCategoryId);

            const breadcrumbs = this.state.breadcrumbs;

            return (
                <div id="war-categories">
                    <nav className="breadcrumb">
                        <span
                            className={`breadcrumb-item${
                                this.state.parentCategoryId === 0 ? ' active' : ' cursor-pointer'
                            }`}
                            onClick={() => this.goBackToTopLevel()}
                        >
                            All categories
                        </span>
                        {breadcrumbs.map((breadcrumb, index) => {
                            return (
                                <Breadcrumb
                                    categoryId={breadcrumb[0]}
                                    categoryName={breadcrumb[1]}
                                    goBackToPreviousLevel={this.goBackToPreviousLevel.bind(this)}
                                    key={index}
                                    isActive={Number(breadcrumb[0]) === this.state.parentCategoryId}
                                />
                            );
                        })}
                    </nav>
                    <div className="card-deck animated fadeIn mb-3">
                        {shouldDisplayDocs
                            ? docArray.map((doc, index) => {
                                  return (
                                      <WarDocCard
                                          key={index}
                                          isNew={areDocsNew[doc.WarDocId]}
                                          markDocAsRead={this.markDocAsRead.bind(this)}
                                          fetchDocument={this.fetchDocument.bind(this)}
                                          doc={doc}
                                      />
                                  );
                              })
                            : warArray.map((war, index) => {
                                  return (
                                      <WarCatCard
                                          key={index}
                                          war={war}
                                          isNew={areCatsNew[war.WarCatId]}
                                          goToNextLevel={this.goToNextLevel.bind(this)}
                                      />
                                  );
                              })}
                    </div>
                </div>
            );
        }
    },
);

export default WarPanel;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/War/WarPanel.js